import * as shims from "./shims/index";

export function shimmer($logger) {
	const context = {};

	return {
		request: (config) => {
			context[config.url] = config?.context;

			return config;
		},
		response: (resp) => {
			resp = Object.values(shims)
				.filter(shim => shim?.[0](resp))
				.reduce((accumulatedResp, currentShim) => currentShim[1](accumulatedResp, context[resp.config.url]), resp);

			return resp;
		}, 
		responseError: (err) => {
			const resp = Object.values(shims)
				.filter(shim => shim?.[0](err))
				.reduce((accumulatedResp, currentShim) => {
					return currentShim[1](accumulatedResp, context[err.config.url]); 
				}, err);

			return resp;
		}
	};
}